import api from "@/libs/axios";
import * as endpoints from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: () => ({
    centres: [],
    loading: false,
    working: false,
  }),
  getters: {
    centres(state) {
      return state.centres;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    centres(state, payload) {
      state.centres = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async getCentres({ commit }) {
      commit("setLoading", true);

      await api.get(endpoints.SERVICE_CENTRES).then((res) => {
        commit("centres", res.data.data);
      });
      commit("setLoading", false);
    },
    async addNewCentre({ commit, dispatch }, payload) {
      commit("setWorking", true);
      await api.post(endpoints.SERVICE_CENTRES, payload).then((res) => {
        dispatch("handleResponse", res);
      });

      commit("setWorking", false);
    },
    async updateCentre({ commit, dispatch }, payload) {
      commit("setWorking", true);
      await api
        .put(endpoints.SERVICE_CENTRES_BY_ID(payload.id), payload)
        .then((res) => {
          dispatch("handleResponse", res);
        });
      commit("setWorking", false);
    },
    async deleteCentre({ commit, dispatch }, id) {
      commit("setLoading", true);
      await api.delete(endpoints.SERVICE_CENTRES_BY_ID(id)).then((res) => {
        dispatch("handleResponse", res);
      });
    },
    handleResponse({ dispatch, commit }, res) {
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",

            variant: "danger",
          },
        });
        commit("setWorking", false);
        commit("setLoading", false);
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",

            variant: "success",
          },
        });
        dispatch("getCentres");
      }
    },
  },
};
